import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {CommentModel} from '@Common/widgets/general/comments/interfaces/comment.model';
import {Subject} from 'rxjs';
import {CommentTriggerModel} from '@Common/widgets/general/comments/service/comment-trigger.model';

@Injectable({ providedIn: 'root' })
export class CommentService extends DaoGeneric<CommentModel> {
  private url = `${environment.baseUrl}/core/comment_generic/`;
  private _commentChangedSubject = new Subject<CommentTriggerModel>();
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  /**
   * Communication sur les commentaire : ajout / suppression
   */
  public get onCommentChanged$() {
    return this._commentChangedSubject.asObservable();
  }
  public triggerComment(commentTrigger: CommentTriggerModel) {
    this._commentChangedSubject.next(commentTrigger);
  }

  /**
   * Envoie la notification par défaut du message
   * @param {CommentModel} comment
   * @param {string[]} tos : les destinataires séparés par un ;
   * @param {string} title : l'objet du mail, par défaut "Nouveau message"
   * @param {string} link : le lien inclut au mail vers la vue message, par défaut pas de lien
   * @param {string} linkLabel : le libellé du bouton link
   */
  public sendmail(comment: CommentModel, tos: string[], title: string = null, link = null, linkLabel = null) {
    const url = `${this.url}${comment.id}/send_comment/`;
    const data = {
      content_plain: comment.content_plain,
      tos: tos.join(';'),
      title: title,
      link: link,
      link_label: linkLabel
    };
    return this.httpClient.post(url, data);
  }
  getRootUrl(): string {
    return this.url;
  }
}
